import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Studiedjungeln from "./pages/Studiedjungeln";
import Mobilappar from "./pages/Mobilappar";
import Bokbubblan from "./pages/Bokbubblan";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/studiedjungeln" element={<Studiedjungeln />} />
        <Route path="/mobilappar" element={<Mobilappar />} />
        <Route path="/bokbubblan" element={<Bokbubblan />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
